(function($) {

	$('.gallery-filters__button').on('click', function(){
		$('.gallery-filters__button--active').removeClass('gallery-filters__button--active');
		$('.rcr-gallery__image--active').removeClass('rcr-gallery__image--active');

		$(this).addClass('gallery-filters__button--active');
		$('.js-gallery-filters__active-text').text($(this).text());
		
		var slug = $(this).data('slug');
		switch(slug) {
			case '*':
				$('.rcr-gallery__image').addClass('rcr-gallery__image--active');
				break;
			default:
				$('.rcr-gallery__image.'+slug).addClass('rcr-gallery__image--active');
		}
		
	});

	$('.js-open-filters-list').on('click', function(event) {
		event.preventDefault();
		$('.js-filters-list').toggleClass('gallery-filters__list--active');
	});


	$(".rcr-gallery__image").fancybox({
		autoCenter : true,
		fixed: false,
		padding: 0,
	    helpers : {
	        title: {
	            type: 'over'
	        }
	    }
	});

	// $(window).bind('resize', function() {
	//     var top = ($(window).height() / 2) - ($(".fancybox-wrap").outerHeight() / 2);
	//     var left = ($(window).width() / 2) - ($(".fancybox-wrap").outerWidth() / 2);
	//     $(".fancybox-wrap").css({ top: top, left: left});
	// }).trigger('resize');

})( jQuery );